import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 8h4","key":"svg-0"}],["path",{"d":"M9 8v8","key":"svg-1"}],["path",{"d":"M18 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1","key":"svg-2"}]]

/**
 * IconMathTg
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbWF0aC10ZyIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNNyA4aDQiIC8+CiAgPHBhdGggZD0iTTkgOHY4IiAvPgogIDxwYXRoIGQ9Ik0xOCA4aC0yYTIgMiAwIDAgMCAtMiAydjRhMiAyIDAgMCAwIDIgMmgydi00aC0xIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/math-tg
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconMathTg = createReactComponent('outline', 'math-tg', 'MathTg', __iconNode);

export default IconMathTg;